var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { mask } from './mask';
var DomElementBuilder = /** @class */ (function () {
    function DomElementBuilder(tag, parent) {
        if (typeof tag === "string") {
            this.element = document.createElement(tag);
        }
        else {
            this.element = tag;
        }
        if (parent && this.element.parentElement !== parent) {
            parent.appendChild(this.element);
        }
    }
    DomElementBuilder.prototype.addChild = function (tag, childBuilder) {
        var builder = domel(tag, this.element);
        if (childBuilder) {
            childBuilder(builder);
        }
        return this;
    };
    DomElementBuilder.prototype.addChildElement = function (element) {
        if (element) {
            this.element.appendChild(element);
        }
        return this;
    };
    DomElementBuilder.prototype.attr = function (attrId, attrValue) {
        this.element.setAttribute(attrId, attrValue);
        return this;
    };
    DomElementBuilder.prototype.id = function (value) {
        return this.attr("id", value);
    };
    DomElementBuilder.prototype.focus = function () {
        this.element.focus();
        return this;
    };
    DomElementBuilder.prototype.title = function (value) {
        return this.attr('title', value);
    };
    DomElementBuilder.prototype.data = function (dataId, dataValue) {
        if (dataValue === void 0) { dataValue = null; }
        if (dataValue === null) {
            this.element.removeAttribute('data-' + dataId);
            return this;
        }
        else {
            return this.attr('data-' + dataId, dataValue);
        }
    };
    DomElementBuilder.prototype.show = function () {
        return this.removeStyle('display');
    };
    DomElementBuilder.prototype.hide = function (toHide) {
        if (toHide === void 0) { toHide = true; }
        return (toHide) ? this.setStyle('display', 'none') : this;
    };
    DomElementBuilder.prototype.visible = function (isVisible) {
        if (isVisible === void 0) { isVisible = true; }
        return isVisible ? this.setStyle('visibility', 'visible') : this.setStyle('visibility', 'hidden');
    };
    DomElementBuilder.prototype.isVisible = function () {
        return !!(this.element.offsetWidth || this.element.offsetHeight || this.element.getClientRects().length);
    };
    DomElementBuilder.prototype.addClass = function (className) {
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        if (className) {
            var fullList = __spreadArrays(className.trim().split(" "), classNames);
            for (var i = 0; i < fullList.length; i++)
                this.element.classList.add(fullList[i]);
        }
        return this;
    };
    DomElementBuilder.prototype.removeClass = function (className) {
        var classNames = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            classNames[_i - 1] = arguments[_i];
        }
        if (className) {
            var fullList = __spreadArrays(className.trim().split(" "), classNames);
            for (var i = 0; i < fullList.length; i++)
                this.element.classList.remove(fullList[i]);
        }
        return this;
    };
    DomElementBuilder.prototype.toggleClass = function (className, force) {
        if (force === void 0) { force = undefined; }
        if (className) {
            this.element.classList.toggle(className, force);
        }
        return this;
    };
    DomElementBuilder.prototype.on = function (eventType, listener) {
        var eventTypes = eventType.split(' ');
        for (var i = 0; i < eventTypes.length; i++) {
            this.element.addEventListener(eventTypes[i], listener);
        }
        return this;
    };
    DomElementBuilder.prototype.off = function (eventType, listener) {
        var eventTypes = eventType.split(' ');
        for (var i = 0; i < eventTypes.length; i++) {
            this.element.removeEventListener(eventTypes[i], listener);
        }
        return this;
    };
    DomElementBuilder.prototype.setStyle = function (styleId, styleValue) {
        this.element.style.setProperty(styleId, styleValue);
        return this;
    };
    DomElementBuilder.prototype.removeStyle = function (styleId) {
        this.element.style.removeProperty(styleId);
        return this;
    };
    DomElementBuilder.prototype.text = function (text) {
        this.element.innerText = text;
        return this;
    };
    DomElementBuilder.prototype.html = function (html) {
        this.element.innerHTML = html;
        return this;
    };
    DomElementBuilder.prototype.clear = function () {
        var oldElem = this.element;
        this.element = document.createElement(this.element.tagName);
        oldElem.replaceWith(this.element);
    };
    DomElementBuilder.prototype.addText = function (text) {
        var textEl = document.createTextNode(text);
        this.element.appendChild(textEl);
        return this;
    };
    DomElementBuilder.prototype.addHtml = function (html) {
        this.element.innerHTML += html;
        return this;
    };
    DomElementBuilder.prototype.toDOM = function () {
        return this.element;
    };
    DomElementBuilder.prototype.appendTo = function (parent) {
        if (parent) {
            parent.appendChild(this.element);
        }
        return this;
    };
    return DomElementBuilder;
}());
export { DomElementBuilder };
var DomTextAreaElementBuilder = /** @class */ (function (_super) {
    __extends(DomTextAreaElementBuilder, _super);
    function DomTextAreaElementBuilder(element, parent) {
        var _this = this;
        if (element) {
            _this = _super.call(this, element, parent) || this;
        }
        else {
            _this = _super.call(this, "textarea", parent) || this;
        }
        return _this;
    }
    DomTextAreaElementBuilder.prototype.name = function (value) {
        this.element.name = value;
        return this;
    };
    DomTextAreaElementBuilder.prototype.rows = function (rows) {
        this.element.rows = rows;
        return this;
    };
    DomTextAreaElementBuilder.prototype.cols = function (cols) {
        this.element.cols = cols;
        return this;
    };
    DomTextAreaElementBuilder.prototype.value = function (value) {
        this.element.value = value;
        return this;
    };
    return DomTextAreaElementBuilder;
}(DomElementBuilder));
export { DomTextAreaElementBuilder };
var DomInputElementBuilder = /** @class */ (function (_super) {
    __extends(DomInputElementBuilder, _super);
    function DomInputElementBuilder(element, parent) {
        var _this = this;
        if (element) {
            _this = _super.call(this, element, parent) || this;
        }
        else {
            _this = _super.call(this, "input", parent) || this;
        }
        return _this;
    }
    DomInputElementBuilder.prototype.name = function (value) {
        this.element.name = value;
        return this;
    };
    DomInputElementBuilder.prototype.type = function (value) {
        this.element.type = value;
        return this;
    };
    DomInputElementBuilder.prototype.size = function (value) {
        this.element.size = value;
        return this;
    };
    DomInputElementBuilder.prototype.value = function (value) {
        if (value instanceof Date) {
            this.element.valueAsDate = value;
        }
        else if (typeof value === "number") {
            this.element.valueAsNumber = value;
        }
        else {
            this.element.value = value;
        }
        return this;
    };
    DomInputElementBuilder.prototype.mask = function (maskPattern) {
        mask(this.element, maskPattern);
        return this;
    };
    return DomInputElementBuilder;
}(DomElementBuilder));
export { DomInputElementBuilder };
var DomSelectElementBuilder = /** @class */ (function (_super) {
    __extends(DomSelectElementBuilder, _super);
    function DomSelectElementBuilder(element, parent) {
        var _this = this;
        if (element) {
            _this = _super.call(this, element, parent) || this;
        }
        else {
            _this = _super.call(this, "select", parent) || this;
        }
        return _this;
    }
    DomSelectElementBuilder.prototype.addOption = function (value) {
        var option = document.createElement('option');
        if (typeof value === "string") {
            option.value = value;
            option.innerHTML = value;
        }
        else {
            option.value = value.value;
            option.innerHTML = value.title || value.value;
            option.selected = value.selected || false;
        }
        this.element.appendChild(option);
        return this;
    };
    DomSelectElementBuilder.prototype.value = function (value) {
        this.element.value = value;
        return this;
    };
    return DomSelectElementBuilder;
}(DomElementBuilder));
export { DomSelectElementBuilder };
export function domel(tag, parent) {
    if (tag === "div" || tag instanceof HTMLDivElement) {
        return new DomElementBuilder(tag, parent);
    }
    if (tag === "span" || tag instanceof HTMLSpanElement) {
        return new DomElementBuilder(tag, parent);
    }
    else if (tag === "a" || tag instanceof HTMLAnchorElement) {
        return new DomElementBuilder(tag, parent);
    }
    else if (tag === "button" || tag instanceof HTMLButtonElement) {
        return new DomElementBuilder(tag, parent);
    }
    else if (tag === "img" || tag instanceof HTMLImageElement) {
        return new DomElementBuilder(tag, parent);
    }
    else if (tag === "input" || tag instanceof HTMLInputElement) {
        return new DomInputElementBuilder(tag instanceof HTMLInputElement ? tag : null, parent);
    }
    else if (tag === "textarea" || tag instanceof HTMLTextAreaElement) {
        return new DomTextAreaElementBuilder(tag instanceof HTMLTextAreaElement ? tag : null, parent);
    }
    else if (tag === "select" || tag instanceof HTMLSelectElement) {
        return new DomSelectElementBuilder(tag instanceof HTMLSelectElement ? tag : null, parent);
    }
    return new DomElementBuilder(tag, parent);
}
//# sourceMappingURL=dom_elem_builder.js.map